module.exports = __webpack_public_path__ + "media/images/area/icon_weather_13-a40a65dcdd5613c01a802ce15bb8c0c7.png";